module.exports = __webpack_public_path__ + "img/price-bg.13295bac.gif";